/**
 * What day each kind of figure is counted on, as the definition tooltips say it. Engagement is counted against the
 * day its notification was sent, so the latest days are still accruing clicks and purchases and read low until they
 * have matured; the sentence says so, because nothing else on the page does.
 */
export const ENGAGEMENT_ATTRIBUTION_NOTE =
    'Counted on the day the notification was sent, like the rest of Pushly. The most recent days keep growing as subscribers click.'

/** Sends are final the day they go out, so their note carries no warning about growing. */
export const SENDS_ATTRIBUTION_NOTE = 'Counted on the day the notifications were sent.'

/** A definition followed by the note on what day it is counted on, as one tooltip text. */
export const withAttributionNote = (definition: string, note: string): string => `${definition}. ${note}`
